export function makeAsync(fn, ...args) {
  return () =>
    new Promise((resolve) => {
      fn(...args, () => {
        resolve();
      });
    });
}
